import type { CustomFlowbiteTheme } from 'flowbite-react';

export const progressTheme: CustomFlowbiteTheme['progress'] = {
  base: 'w-full overflow-hidden rounded-full bg-titan-night-200',
  label: 'mb-1 flex justify-between font-medium',
  bar: 'rounded-full text-center font-medium leading-none text-titan-night-300 space-x-2',
  color: {
    dark: 'bg-titan-night-600',
    blue: 'bg-titan-blue-600',
    red: 'bg-titan-folly-600',
    green: 'bg-green-600',
    yellow: 'bg-titan-yellow-400',
    indigo: 'bg-indigo-600',
    purple: 'bg-purple-600',
  },
  size: {
    sm: 'h-1.5',
    md: 'h-2.5',
    lg: 'h-4',
    xl: 'h-6',
  },
};
